import request from "./Request.js";

//数据统计
export const statisticCount = async (data, callback) => {
  let d = await request("get", "/mws/statistic/base/baseInfo/public", data);
  return callback(d);
};

//当前数据统计
export const currentStatisticCount = async (data, callback) => {
  let d = await request("get", "/mws/statistic/flow/currentData/public", data);
  return callback(d);
};

//当月用气量
export const currentMonthData = async (data, callback) => {
  let d = await request("get", "/mws/statistic/flow/currentMonthData/public", data);
  return callback(d);
}

//瞬时总流量
export const lastTotalFlowData = async (data, callback) => {
  let d = await request("get", "/mws/statistic/flow/lastTotalFlowData/public", data);
  return callback(d);
}

//剩余可用时长
export const unusedTime = async (data, callback) => {
  let d = await request(
    "get",
    "/mws/collectPameter/haveTimeRank/public",
    data
  );
  return callback(d);
};

//站点总用量排行
export const siteAllUsedRank = async (query, data, callback) => {
  let d = await request(
    "get",
    `/mws/statistic/flow/flowTotalDataRank/public?startTime=${query.startTime}&endTime=${query.endTime}&dataOrder=DESC`,
    data
  );
  return callback(d);
};

//大数据统计
export const massStatistic = async (query, data, callback) => {
  let d = await request(
    "get",
    `/mws/statistic/flow/totalData/public?startTime=${query.startTime}&endTime=${query.endTime}`,
    data
  );
  return callback(d);
};

//平均天用量
export const averageUseMount = async (query, data, callback) => {
  let d = await request(
    "get",
    `/mws/statistic/flow/avgDayData/public?startTime=${query.startTime}&endTime=${query.endTime}`,
    data
  );
  return callback(d);
};

//地图
export const getMapInfo = async (data, callback) => {
  let d = await request("get", `mws/site/map/public`, data);
  return callback(d);
};

export const siteCount = async (data, callback) => {
  let d = await request("get", `/mws/statistic/base/siteCount/public`, data);
  return callback(d);
};
//获取密码状态
export const getPwdType = async (data, callback) => {
  let d = await request("get", `/ucms/user/getPwdType`, data);
  return callback(d);
};
export const siteInfo = async(siteId, callback) => {
  let d = await request("get", `/mws/site/${siteId}/cylinder/public`, null);
  return callback(d);
}
